// src/data/projectsData.js
const projectsData = [
    {
      id: 1,
      title: 'React and Python Server Information Application',
      description: 'View a collection of servers at a glance. Quickly view information a server such as packages installed or assoiciated team.',
      github: 'https://github.com/acharnovich/server_tracker',
      demo: 'https://devops-platform-demo.com',
      image: 'https://via.placeholder.com/400x300', // Replace with real project image
    },
    {
      id: 2,
      title: 'Golang Videogame Release Website',
      description: 'Gets release dates for upcoming videogames.',
      github: 'https://github.com/acharnovich/videogame-release-site',
      demo: 'https://ecommerce-dashboard-demo.com',
      image: 'https://via.placeholder.com/400x300',
    },
    {
      id: 3,
      title: 'Portfolio Website',
      description: 'Personal Portfolio React Website',
      github: 'https://github.com/acharnovich/my-portfolio',
      demo: 'https://portfolio-demo.com',
      image: 'https://via.placeholder.com/400x300',
    },
  ];
  
  export default projectsData;